import React, { useState } from "react";
import "./App.css";
import { HashRouter, BrowserRouter as Router } from "react-router-dom";
import Routers from "./components/Routers";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider } from "react-query";
import {
  createTheme,
  // ThemeProvider
} from "@mui/material";
import HelpModeless from "./components/HelpModeless";
import { ColorThemeProvider } from "./components/report/setting/ColorThemeContext";
import { DarkModeProvider } from "./hooks/useDarkMode";
import { TutorialProvider, useTutorial } from "./context/TutorialContext";
import { TutorialToast } from "./components/TutorialToast";
import { TutorialJoyride } from "./components/TutorialJoyride";
import { ThemeProvider } from "./theme/ThemeProvider";
import { ModeStyle } from "./styles/ModeStyle";
import { DevModeProvider } from "./context/DevModeContext";

const theme = createTheme({
  palette: {
    primary: {
      main: "#59a9eb",
      // main: "#1976d2",
    },
  },
});

export const MODE = localStorage.getItem("appModeOverride") ?? process.env.APP_MODE ?? "default";

function App() {
  const { toastVisible } = useTutorial();

  const queryClient = new QueryClient();
  const [squareX, setSquareX] = useState(0); // 네모의 x 좌표
  const [contentOffset, setContentOffset] = useState(0); // content의 x 좌표
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0); // 드래그 시작 시 마우스 위치

  // 드래그 시작 시
  const handleDragStart = (e: React.MouseEvent) => {
    setIsDragging(true);
    setStartX(e.clientX); // 현재 마우스 위치를 기준으로 드래그 시작
  };

  // 드래그 중
  const handleDrag = (e: React.MouseEvent) => {
    if (!isDragging) return;

    const deltaX = e.clientX - startX; // 드래그한 거리
    const newSquareX = squareX + deltaX; // 새로운 네모 위치 계산

    // 네모가 content 영역을 벗어나는지 확인
    if (newSquareX < 0) {
      setContentOffset((prevOffset) => prevOffset - deltaX); // content 위치 업데이트
    }

    setSquareX(newSquareX); // 네모 위치 업데이트
    setStartX(e.clientX); // 마우스 위치 업데이트
  };

  // 드래그 종료 시
  const handleDragEnd = () => {
    setIsDragging(false);
  };

  return (
    <DarkModeProvider>
      <ThemeProvider
      // theme={theme}
      >
        <ColorThemeProvider>
          <QueryClientProvider client={queryClient}>
            <ModeStyle />
            <DevModeProvider>
              <div data-app-mode={MODE}>
                <HashRouter>
                  <Routers />
                </HashRouter>
              </div>
            </DevModeProvider>
            {/* <ReactQueryDevtools initialIsOpen={false} position="bottom-right" /> */}
            <ToastContainer limit={3} autoClose={3000} />
            <TutorialToast visible={toastVisible} />
            <TutorialJoyride />
          </QueryClientProvider>
          <HelpModeless />
        </ColorThemeProvider>
      </ThemeProvider>
    </DarkModeProvider>
  );
}

export default App;
